import * as CONSTANTS from "../../common/utils/data_validations"
import * as Yup from "yup"
import { useFormik } from "formik"
import React, { useState, useEffect, useMemo } from 'react';
import { us_states } from "../../common/data/us_states"
import { INTEGRATION_LEAD_TYPES, PRODUCT_TYPES, PRODUCT_TYPE_IDS, MonthlyBudgetType, INFINITY, MODIFICATION_TYPE, REPORTING_TIMEZONE, LEAD_TYPES, NAME_OF_LEAD_TYPES, animatedlogo, MAX_BUDGETS, LEAD_TYPES_OPTIONS, getProductTypeById } from 'helpers/sf_constants';
import {
    Card,
    Col,
    Container,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Row,
    UncontrolledTooltip,
} from "reactstrap";
import MetaTags from "react-meta-tags"
import Select from "react-select"
import { AppConfiguration } from "config";
import { capitalizeWord, getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass, maxBudgetAndUnitsLimit } from "helpers/sf_utils";
import NumberFormat from "react-number-format";
import { DAY_ARRARY, DEFAULT_CAMPAIGN_SCHEDULES } from "helpers/sf_campaign_schedule_helper";
import { setCampaignsToBeCreated } from "store/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { WHITE_LABELED_PRODUCT_NAMES } from "config";
import useRegistratonPage from "hooks/useRegistratonPage";
import useFilteredLeadTypes from "hooks/useFilteredLeadTypes";

const FILTERD_PRODUCT_TYPES = PRODUCT_TYPES.filter((product_type) => product_type.id !== PRODUCT_TYPE_IDS.CLICKS && product_type.id !== PRODUCT_TYPE_IDS.SYNDI_CLICKS)
    .map(el => ({ label: el.name, name: "product_type", value: el.id }))
    .sort((a, b) => b.value - a.value);

const SHARED_AND_EXCLUSIVE_STR = {
    SHARED_LEAD_TYPE: 'shared_lead_type',
    EXCLUSIVE_LEAD_TYPE: 'exclusive_lead_type'
}

const DAILY_BUDGET_OPTIONS = [
    { id: 1, label: 'Unlimited', value: 'Unlimited' },
    { id: 4, label: 'Daily Volume', value: 'Daily Volume' }
];


const US_STATES_OPTIONS = us_states.map(el => ({ label: el.isocode, value: el.name }));

const RegistrationWithCampaignCreation = () => {
    const [selecteMonth, setSelecteMonth] = useState(getOptionFromValueForSelectBox(MonthlyBudgetType[0].options, MonthlyBudgetType[0].options[0].value));
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [arrByDay, setArrByDay] = useState([...DAY_ARRARY]);
    const [selectDailyLimits, setSelectDailyLimits] = useState(DAILY_BUDGET_OPTIONS.find((el) => el.id === 1));
    const [budgetAndLimitInputs, setBudgetAndLimitInputs] = useState({
        "daily_limit_type": "Unlimited",
        "monthly_limit_type": "Unlimited",
        "daily_budget_units": "",
        "monthly_budget_units": "",
        "budget_by_day": []
    });

    const [checkUserInfo, setCheckUserInfo] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const urlParams = new URLSearchParams(location.search);
    const [_is_admin_adding_client, admin_url_param, registration_pending_user_url_param] = useRegistratonPage();

    const { user_info } = useSelector((state) => ({
        user_info: state.Account.set_user_to_be_created,
    }), shallowEqual);

    // redirect handler start
    const onSetUserInfoTimeout = () => {
        setCheckUserInfo(false);
        setTimeout(() => {
            setCheckUserInfo(true);
        }, 1000);
    };

    useEffect(() => {
        //Check if user_info exists, it is a fix for situations when a user directy enters url
        onSetUserInfoTimeout();
    }, []);

    useEffect(() => {
        if (checkUserInfo === true && (!user_info)) {
            ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Please enter user info first' });
            history.push('/register')
        }
    }, [checkUserInfo]);

    // redirect handler end

    // Handle Budget & Limits start
    const handleBudgetAndLimit = (e) => {
        const { name, value } = e.target;
        const newValue = value.replace(/[^0-9.]/g, ''); // removes everything from the number except dot
        setBudgetAndLimitInputs({ ...budgetAndLimitInputs, [name]: newValue });
    };

    const handleDailyLimits = (selected_obj) => {
        setSelectDailyLimits(selected_obj);
        setArrByDay([...DAY_ARRARY]);
        setBudgetAndLimitInputs({ ...budgetAndLimitInputs, daily_budget_units: '' });
    };

    // const handleMonthlyLimits = (e) => {
    //     setSelecteMonth(e);
    //     setBudgetAndLimitInputs({ ...budgetAndLimitInputs, monthly_budget_units: '' });
    // };
    // Handle Budget & Limits end

    // Budget & Limits (array) start
    const handleArrayInputs = (index, e) => {
        const updatedArrByDay = arrByDay.map((item) => {
            const { value } = e.target;
            const newValue = value.replace(/[^0-9.]/g, ''); // removes everything from the number except dot
            if (item.day_id === index) {
                return { ...item, value: newValue };
            }
            return item;
        });
        setArrByDay(updatedArrByDay);
    };
    // Budget & Limits (array) end

    // Budget & Limits (helper) start
    const addDollarSignIfEmpty = (e, index = 0) => {
        if (e.target.value.length === index) {
            e.target.value = '$';
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace') {
            addDollarSignIfEmpty(event, 0);
        }
    };
    // Budget & Limits (helper) end

    // Budget & Limits (html) start
    let DailyLimits_HTML = '';
    switch (selectDailyLimits.value) {
        case 'Budget by Day':
            DailyLimits_HTML = arrByDay.map((item) => (
                <div key={item.day_id} className="me-2 mb-3">
                    <Label className="font-weight-semibold">{capitalizeWord(item.name.slice(0, 3))}</Label>
                    <NumberFormat
                        prefix="$"
                        onClick={addDollarSignIfEmpty}
                        onBlur={addDollarSignIfEmpty}
                        onFocus={addDollarSignIfEmpty}
                        className="form-control"
                        type="text"
                        name={`budget_by_day[${item.day_id}]`}
                        onChange={(e) => handleArrayInputs(item.day_id, e)}
                        value={item.value}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        autoComplete="off"
                        placeholder="$"
                        onKeyDown={handleKeyDown}

                    />
                </div>
            ));
            break;
        case 'Volume by Day':
            DailyLimits_HTML = arrByDay.map((item) => (
                <div key={item.day_id} className="me-2 mb-3">
                    <Label className="font-weight-semibold">{capitalizeWord(item.name.slice(0, 3))}</Label>
                    <NumberFormat
                        className="form-control"
                        suffix=" units"
                        type="text"
                        name={`volume_by_day[${item.day_id}]`}
                        onChange={(e) => handleArrayInputs(item.day_id, e)}
                        value={item.value}
                        decimalScale={0}
                        thousandSeparator
                        autoComplete="off"
                    />
                </div>
            ));
            break;
        case 'Daily Volume':
            DailyLimits_HTML = (
                <div className="me-2 mb-3">
                    <Label className="font-weight-semibold">
                        <strong>Daily Volume</strong>
                    </Label>
                    <NumberFormat
                        suffix=" units"
                        className={`form-control ${visibleAlert && !budgetAndLimitInputs.daily_budget_units ? 'is-invalid' : ''}`}
                        type="text"
                        name="daily_budget_units"
                        onChange={handleBudgetAndLimit}
                        isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.DAILY_VOLUME)}
                        value={budgetAndLimitInputs.daily_budget_units}
                        thousandSeparator
                        decimalScale={0}
                        autoComplete="off"
                    />
                    {(selectDailyLimits?.value !== "Unlimited") && (budgetAndLimitInputs.daily_budget_units < 5) ? (
                        <small className="text-black ms-2">Minimum 5 units per day</small>
                    ) : null
                    }
                </div>
            );
            break;
        case 'Daily Budget':
            DailyLimits_HTML = (
                <div className="me-2 mb-3">
                    <Label className="font-weight-semibold">Daily Budget</Label>
                    <NumberFormat
                        onClick={addDollarSignIfEmpty}
                        onBlur={addDollarSignIfEmpty}
                        onFocus={addDollarSignIfEmpty}
                        className={`form-control ${visibleAlert && !budgetAndLimitInputs.daily_budget_units ? 'is-invalid' : ''}`}
                        prefix="$"
                        type="text"
                        name="daily_budget_units"
                        onChange={handleBudgetAndLimit}
                        value={budgetAndLimitInputs.daily_budget_units}
                        decimalScale={2}
                        isAllowed={(values) => maxBudgetAndUnitsLimit(values, MAX_BUDGETS.DAILY_DOLLAR)}
                        fixedDecimalScale
                        thousandSeparator
                        autoComplete="off"
                        placeholder="$"
                        onKeyDown={handleKeyDown}
                    />
                </div>
            );
            break;
        case 'Unlimited':
            DailyLimits_HTML = '';
            break;
        default: DailyLimits_HTML = '';
            break;
    }

    // Budget & Limits (html) end

    const redirectToPrompt = () => {
        if (urlParams.get('invoice_user') !== null) {
            history.push("/register/create-campaign-prompt?invoice_user=" + urlParams.get('invoice_user') + registration_pending_user_url_param)
        } else if (urlParams.get('inv_sid') !== null) {
            history.push("/register/create-campaign-prompt?inv_sid=" + urlParams.get('inv_sid') + admin_url_param + registration_pending_user_url_param)
        } else if (urlParams.get('sid') !== null) {
            history.push("/register/create-campaign-prompt?sid=" + urlParams.get('sid') + admin_url_param + registration_pending_user_url_param)
        } else {
            history.push("/register/create-campaign-prompt" + registration_pending_user_url_param.replace(/&/, '?'))
        }
    }

    const productName = AppConfiguration.PRODUCT_NAME

    const user_state = user_info?.state.toString()
    const matchedState = US_STATES_OPTIONS.find(option => option.label === user_state);
    const initialStateSelection = user_info?.state ? [{ label: matchedState.label, value: matchedState.value }] : null;

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: user_info?.email || "",
            phone_num: user_info?.phone_num || "",
            shared_lead_type: SHARED_AND_EXCLUSIVE_STR.SHARED_LEAD_TYPE,
            campaign_name: "",
            lead_type: getOptionFromValueForSelectBox(LEAD_TYPES_OPTIONS, INTEGRATION_LEAD_TYPES[0].id),
            product_type: productName == WHITE_LABELED_PRODUCT_NAMES.GOAL ? PRODUCT_TYPE_IDS.QUOTE_FUNNELS : PRODUCT_TYPE_IDS.LEADS,
            state: initialStateSelection,
        },
        validationSchema: Yup.object({
            email: Yup.string().when('product_type', {
                is: PRODUCT_TYPE_IDS.LEADS,
                then: Yup.string().email().required(CONSTANTS.STR_INVALID_EMAIL)
            }),
            phone_num: Yup.string().when('product_type', {
                is: PRODUCT_TYPE_IDS.CALLS,
                then: Yup.string().matches(CONSTANTS.phoneRegExp, CONSTANTS.STR_INVALID_PHONE_NUMBER).required(CONSTANTS.STR_REQUIRED_PHONE_NUMBER)
            }),
            state: Yup.array().of(
                Yup.object().shape({
                    label: Yup.string().required("Label is required"),
                    value: Yup.string().required("Value is required"),
                })
            ).min(1, CONSTANTS.STR_REQUIRED_FIELD).required(CONSTANTS.STR_REQUIRED_FIELD),
            campaign_name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
        }),
        onSubmit: values => {
            // Monthly Budget & Volume
            let monthly_budget_info = {
                monthly_budget_units: null,
                monthly_dollar_budget: null,
            };

            if (selecteMonth.value === 'Monthly Budget') {
                if (!budgetAndLimitInputs.monthly_budget_units) {
                    setVisibleAlert(true);
                    return;
                }
                monthly_budget_info = { ...monthly_budget_info, monthly_dollar_budget: budgetAndLimitInputs.monthly_budget_units };
            } else if (selecteMonth.value === 'Monthly Volume') {
                if (!budgetAndLimitInputs.monthly_budget_units) {
                    setVisibleAlert(true);
                    return;
                }
                monthly_budget_info = { ...monthly_budget_info, monthly_budget_units: budgetAndLimitInputs.monthly_budget_units };
            } else if (selecteMonth.value === 'Unlimited') {
                monthly_budget_info = { monthly_dollar_budget: INFINITY, monthly_budget_units: INFINITY };
            }

            // Daily Budget & Volume
            const daily_budget_data = [];
            if (selectDailyLimits.value === 'Unlimited') {
                for (let i = 0; i < 7; i++) {
                    daily_budget_data[i] = {
                        day_id: i,
                        dollar_budget: INFINITY,
                        modification_type: MODIFICATION_TYPE.new,
                        volume_budget: INFINITY,
                    };
                }
            } else if (selectDailyLimits.value === 'Daily Budget') {
                if (!budgetAndLimitInputs.daily_budget_units) {
                    setVisibleAlert(true);
                    return;
                }
                for (let i = 0; i < 7; i++) {
                    daily_budget_data[i] = {
                        day_id: i,
                        dollar_budget: budgetAndLimitInputs.daily_budget_units,
                        modification_type: MODIFICATION_TYPE.new,
                        volume_budget: null,
                    };
                }
            } else if (selectDailyLimits.value === 'Daily Volume') {
                if (!budgetAndLimitInputs.daily_budget_units) {
                    setVisibleAlert(true);
                    return;
                }
                for (let i = 0; i < 7; i++) {
                    daily_budget_data[i] = {
                        day_id: i,
                        dollar_budget: null,
                        modification_type: MODIFICATION_TYPE.new,
                        volume_budget: budgetAndLimitInputs.daily_budget_units,
                    };
                }
            } else if (selectDailyLimits.value === 'Budget by Day') {
                // TODO: handle cases where user doesn't leaves the field blank
                if ((!arrByDay[0].value) &&
                    (!arrByDay[1].value) &&
                    (!arrByDay[2].value) &&
                    (!arrByDay[3].value) &&
                    (!arrByDay[4].value) &&
                    (!arrByDay[5].value) &&
                    (!arrByDay[6].value)) {
                    for (let i = 0; i < 7; i++) {
                        daily_budget_data[i] = {
                            day_id: i,
                            dollar_budget: INFINITY,
                            modification_type: MODIFICATION_TYPE.new,
                            volume_budget: INFINITY,
                        };
                    }
                } else {
                    for (let i = 0; i < arrByDay.length && i < 7; i++) {
                        daily_budget_data[i] = {
                            day_id: arrByDay[i].day_id,
                            dollar_budget: arrByDay[i].value,
                            modification_type: MODIFICATION_TYPE.new,
                            volume_budget: null,
                        };
                    }
                }
            } else if (selectDailyLimits.value === 'Volume by Day') {
                if ((!arrByDay[0].value) &&
                    (!arrByDay[1].value) &&
                    (!arrByDay[2].value) &&
                    (!arrByDay[3].value) &&
                    (!arrByDay[4].value) &&
                    (!arrByDay[5].value) &&
                    (!arrByDay[6].value)) {
                    for (let i = 0; i < 7; i++) {
                        daily_budget_data[i] = {
                            day_id: i,
                            dollar_budget: INFINITY,
                            modification_type: MODIFICATION_TYPE.new,
                            volume_budget: INFINITY,
                        };
                    }
                } else {
                    for (let i = 0; i < arrByDay.length && i < 7; i++) {
                        daily_budget_data[i] = {
                            day_id: arrByDay[i].day_id,
                            dollar_budget: null,
                            modification_type: MODIFICATION_TYPE.new,
                            volume_budget: arrByDay[i].value,
                        };
                    }
                }
            }
            const data = {
                campaign: {
                    ...values,
                    shared_lead_type: values.product_type === PRODUCT_TYPE_IDS.LEADS ? values.shared_lead_type === SHARED_AND_EXCLUSIVE_STR.SHARED_LEAD_TYPE : null,
                    daily_budget: daily_budget_data,
                    monthly_budget: monthly_budget_info,
                    state: values.state.map(el => el.label),
                    lead_type: values.lead_type.value,
                    campaign_schedules: DEFAULT_CAMPAIGN_SCHEDULES,
                    timezone: REPORTING_TIMEZONE
                }
            }
            dispatch(setCampaignsToBeCreated(data));
            redirectToPrompt();
        },
    });

    const CONDITIONAL_LEAD_TYPE_OPTIONS = useMemo(() => {
        return LEAD_TYPES.filter(lead => {
            if (validation?.values?.product_type === PRODUCT_TYPE_IDS.CALLS) {
                return true;
            }
            return lead.name !== NAME_OF_LEAD_TYPES.P_C_BUNDLE;
        })
    }, [validation.values.product_type]);

    const selected_product_type = getProductTypeById(validation.values.product_type)?.name
    const filteredLeadTypes = useFilteredLeadTypes(CONDITIONAL_LEAD_TYPE_OPTIONS, selected_product_type, true);
    const filteredUSStatesOptions = US_STATES_OPTIONS.filter(option => 
        !validation.values.state?.some(selected => selected.label === option.label)
    );
    return (
        <React.Fragment>
            <MetaTags>
                <title>Create Campaign | {AppConfiguration.WEBSITE}</title>
            </MetaTags>
            <div className="account-pages my-1 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={6}>
                            <Card className="overflow-hidden">
                                <div className="bg-white bg-soft">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="text-center p-4">
                                                <img src={animatedlogo} height={32} />
                                            </div>
                                            <div className="text-dark px-4">
                                                <h5 className={`${getPrimaryTextClass()} b`}>Create New Campaign</h5>
                                                <Form onSubmit={(event) => {
                                                    event.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}>
                                                    <Row>
                                                        <Col md={12}>
                                                            <FormGroup className="mt-2">
                                                                <Label for="campaignName">Select Product</Label>
                                                                <div className="d-flex flex-wrap gap-3">
                                                                    {
                                                                        FILTERD_PRODUCT_TYPES.map(single_lead_type => {
                                                                            return (
                                                                                <div className="campaign-type"
                                                                                    key={single_lead_type.value}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        className="btn-check"
                                                                                        name={single_lead_type.name}
                                                                                        value={single_lead_type.value}
                                                                                        onClick={() => {
                                                                                            validation.setFieldValue('product_type', single_lead_type.value);
                                                                                        }}
                                                                                        defaultChecked={single_lead_type.value === validation?.values?.product_type}
                                                                                        id={`register-campaign-creation-${single_lead_type.value}`}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    <Label className="btn text-capitalize"
                                                                                        htmlFor={`register-campaign-creation-${single_lead_type.value}`}>
                                                                                        {single_lead_type.value === PRODUCT_TYPE_IDS.CALLS && (
                                                                                            <img className="me-2" style={{ width: '13px' }} src={`/assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/${single_lead_type.label}.png`} alt="" />
                                                                                        )}
                                                                                        {single_lead_type.value === PRODUCT_TYPE_IDS.LEADS && (
                                                                                            <img className="me-2" style={{ width: '20px' }} src={`/assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/${single_lead_type.label}.png`} alt="" />
                                                                                        )}
                                                                                        {single_lead_type.value === PRODUCT_TYPE_IDS.QUOTE_FUNNELS && (
                                                                                            <img className="me-2" style={{ width: '15px' }} src={`/assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/clicks.png`} alt="" />
                                                                                        )}
                                                                                        {single_lead_type.label}
                                                                                    </Label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="campaignName">Type</Label>
                                                                <div className="mt-2 mb-3">
                                                                    {validation?.values?.product_type === PRODUCT_TYPE_IDS.LEADS && (
                                                                        <div className="d-flex align-items-center gap-3 mb-3">
                                                                            <div className="text-center d-flex align-items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    className="me-1"
                                                                                    name='shared_lead_type'
                                                                                    value={SHARED_AND_EXCLUSIVE_STR.SHARED_LEAD_TYPE}
                                                                                    id='shared_lead_type'
                                                                                    defaultChecked={validation?.values?.shared_lead_type === SHARED_AND_EXCLUSIVE_STR.SHARED_LEAD_TYPE}
                                                                                    onChange={validation.handleChange}
                                                                                    autoComplete="off"
                                                                                />
                                                                                <Label className="mb-0" htmlFor={`shared_lead_type`}>
                                                                                    Shared
                                                                                </Label>
                                                                            </div>
                                                                            <div className="text-center d-flex align-items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    className="me-1"
                                                                                    name='shared_lead_type'
                                                                                    value={SHARED_AND_EXCLUSIVE_STR.EXCLUSIVE_LEAD_TYPE}
                                                                                    id='exclusive_lead_type'
                                                                                    defaultChecked={validation?.values?.shared_lead_type === SHARED_AND_EXCLUSIVE_STR.EXCLUSIVE_LEAD_TYPE}
                                                                                    onChange={validation.handleChange}
                                                                                    autoComplete="off"
                                                                                />
                                                                                <Label className="mb-0" htmlFor={`exclusive_lead_type`}>
                                                                                    Exclusive
                                                                                </Label>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <Select
                                                                        classNamePrefix="select2-selection"
                                                                        options={filteredLeadTypes}
                                                                        value={validation?.values?.lead_type}
                                                                        onChange={(selected_obj) => {
                                                                            validation.setFieldValue('lead_type', selected_obj);
                                                                        }}
                                                                        isSearchable={false}
                                                                        required
                                                                    />
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="campaign_name">Name</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="campaign_name"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.campaign_name || ""}
                                                                    invalid={
                                                                        validation.touched.campaign_name &&
                                                                            validation.errors.campaign_name
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                {validation.touched.campaign_name &&
                                                                    validation.errors.campaign_name ? (
                                                                    <FormFeedback type="invalid">
                                                                        {validation.errors.campaign_name}
                                                                    </FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>
                                                        {productName != WHITE_LABELED_PRODUCT_NAMES.GOAL && <Col md={12}>
                                                            <FormGroup>
                                                                <Label className="d-flex align-items-center font-weight-semibold">
                                                                    Daily Limits
                                                                    <i id='daily-limit-tooltip' className='ms-1 bx bx-info-circle text-black bx-xs'></i>
                                                                    <UncontrolledTooltip placement="top" target='daily-limit-tooltip'>
                                                                        Total opportunities you can receive in a day
                                                                    </UncontrolledTooltip>
                                                                </Label>
                                                                <Select
                                                                    name="daily_limit_type"
                                                                    onChange={(e) => {
                                                                        handleDailyLimits(e);
                                                                    }}
                                                                    value={selectDailyLimits}
                                                                    options={DAILY_BUDGET_OPTIONS}
                                                                    classNamePrefix="select2-selection"
                                                                    placeholder=""
                                                                />
                                                            </FormGroup>

                                                            <div>
                                                                {DailyLimits_HTML}
                                                            </div>
                                                        </Col>}
                                                        {/* <Col md={12}>
                                                            <FormGroup className="mt-1 mb-0">
                                                                <Label className="d-flex align-items-center font-weight-semibold">
                                                                    Monthly Limits
                                                                    <i id='monthly-limit-tooltip' className='ms-1 bx bx-info-circle text-black bx-xs'></i>
                                                                    <UncontrolledTooltip placement="top" target='monthly-limit-tooltip'>
                                                                        Total opportunities you can receive in a month
                                                                    </UncontrolledTooltip>
                                                                </Label>
                                                                <Select
                                                                    name="monthly_limit_type"
                                                                    value={selecteMonth}
                                                                    onChange={(e) => {
                                                                        handleMonthlyLimits(e);
                                                                    }}
                                                                    options={MonthlyBudgetType}
                                                                    classNamePrefix="select2-selection"
                                                                />
                                                                <div className="col-xl-2 col-sm-3">
                                                                    {monthlyLimits_HTML}
                                                                </div>
                                                            </FormGroup>
                                                        </Col> */}

                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="campaign_name">Select State(s)</Label>
                                                                <Select
                                                                    classNamePrefix="select2-selection"
                                                                    className={validation.touched.state &&
                                                                        validation.errors.state ? "is-invalid" : ""}
                                                                    options={filteredUSStatesOptions}
                                                                    onChange={(selected_obj) => {
                                                                        validation.setFieldValue('state', selected_obj);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.state || ""}
                                                                    invalid={
                                                                        validation.touched.state &&
                                                                            validation.errors.state
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    isMulti={true}
                                                                />
                                                                {validation.touched.state &&
                                                                    validation.errors.state ? (
                                                                    <FormFeedback type="invalid">
                                                                        {validation.errors.state}
                                                                    </FormFeedback>
                                                                ) : null}
                                                            </FormGroup>
                                                        </Col>

                                                        {validation.values.product_type === PRODUCT_TYPE_IDS.LEADS && (
                                                            <Col md={12}>
                                                                <FormGroup>
                                                                    <Label for="email">Email to Send Leads to</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="email"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.email || ""}
                                                                        invalid={
                                                                            validation.touched.email &&
                                                                                validation.errors.email
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    {validation.touched.email &&
                                                                        validation.errors.email ? (
                                                                        <FormFeedback type="invalid">
                                                                            {validation.errors.email}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>)
                                                        }

                                                        {validation.values.product_type === PRODUCT_TYPE_IDS.CALLS && (
                                                            <>
                                                                <Col md={12}>
                                                                    <FormGroup>
                                                                        <Label for="email">Email to Send Data to</Label>
                                                                        <Input
                                                                            type="text"
                                                                            name="email"
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.email || ""}
                                                                            invalid={
                                                                                validation.touched.email &&
                                                                                    validation.errors.email
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                        {validation.touched.email &&
                                                                            validation.errors.email ? (
                                                                            <FormFeedback type="invalid">
                                                                                {validation.errors.email}
                                                                            </FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={12}>
                                                                    <FormGroup>
                                                                        <Label for="phone_num">Phone Number</Label>
                                                                        <Input
                                                                            type="text"
                                                                            name="phone_num"
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.phone_num || ""}
                                                                            invalid={
                                                                                validation.touched.phone_num &&
                                                                                    validation.errors.phone_num
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                        {validation.touched.phone_num &&
                                                                            validation.errors.phone_num ? (
                                                                            <FormFeedback type="invalid">
                                                                                {validation.errors.phone_num}
                                                                            </FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </>)
                                                        }
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <p className="text-black b mt-3"><span className="me-2">Note:</span>Your campaign will be paused until you decide to activate it</p>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <div className="my-3 d-flex justify-content-between">
                                                                <button className={`btn ${getPrimaryButtonClass()} w-50 btn-block me-1`} disabled={(selectDailyLimits?.value !== "Unlimited") && budgetAndLimitInputs.daily_budget_units < 5} name="submit" type="submit">
                                                                    Continue
                                                                </button>
                                                                <button className="btn btn-light w-50 btn-block ms-1" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    redirectToPrompt();
                                                                }} type="button">
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                            <div className="mt-5 text-center">
                                <p className="text-white">
                                    Already have an account ?{" "}
                                    <Link to="/login" className="font-weight-medium text-sfblue">
                                        {" "}
                                        Login
                                    </Link>{" "}
                                </p>
                                <p className="text-white">© {new Date().getFullYear()} {AppConfiguration.WEBSITE}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default RegistrationWithCampaignCreation
